import { render, staticRenderFns } from "./HeaderArea.vue?vue&type=template&id=5cdfdce5&"
import script from "./HeaderArea.vue?vue&type=script&lang=js&"
export * from "./HeaderArea.vue?vue&type=script&lang=js&"
import style0 from "./HeaderArea.vue?vue&type=style&index=0&id=5cdfdce5&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports